/*
 * Opens the desktop mega menu on hover.
 *
 * This cannot be done in CSS alone. The panel lives inside a <details>, and a
 * browser does not RENDER the contents of a closed <details> at all: the
 * child's own `opacity: 1` and `visibility: visible` compute correctly and
 * still paint nothing. `details::details-content` can override that, but only
 * in recent Chrome, so the panel would stay click-only in Safari and Firefox.
 * Toggling the `open` attribute works everywhere.
 *
 * The listeners sit on the <details> itself. The panel is a DOM descendant of
 * it even though it is positioned under the header, so moving the pointer from
 * the nav item down into the panel never leaves the element and never fires
 * pointerleave. The panel's ::before covers the gap in between.
 *
 * Touch is left alone: there is no hover to speak of, so a tap should behave
 * as a tap and let <summary> do its normal job.
 */
(function () {
  'use strict';

  var DESKTOP = '(min-width: 990px)';
  var CLOSE_DELAY = 80;

  function init() {
    var mq = window.matchMedia(DESKTOP);
    var menus = document.querySelectorAll('details.resemble-mega');

    Array.prototype.forEach.call(menus, function (details) {
      var timer;

      details.addEventListener('pointerenter', function (event) {
        if (!mq.matches || event.pointerType === 'touch') return;
        clearTimeout(timer);
        details.open = true;
      });

      details.addEventListener('pointerleave', function (event) {
        if (!mq.matches || event.pointerType === 'touch') return;
        clearTimeout(timer);
        // A short delay forgives the pointer clipping a corner on its way in.
        timer = setTimeout(function () {
          details.open = false;
        }, CLOSE_DELAY);
      });

      details.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          details.open = false;
          var summary = details.querySelector('summary');
          if (summary) summary.focus();
        }
      });
    });

    // Dropping below the breakpoint hands navigation to the mobile drawer, so
    // anything left open from a wider viewport has to be closed.
    mq.addEventListener('change', function (event) {
      if (event.matches) return;
      Array.prototype.forEach.call(menus, function (details) {
        details.open = false;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
